<template>
  <div class="cartDropdownEmpty">
    <div class="cartDropdownEmpty__title">
      {{ $t('myCart') }}
    </div>
    <cart-empty-info class="cartDropdownEmpty__inner" />
  </div>
</template>
<script>
import CartEmptyInfo from '../Cart/CartEmptyInfo.vue';
export default {
  components: { CartEmptyInfo },
  name: 'CartDropdownEmpty',
};
</script>
<style lang="scss">
.cartDropdownEmpty {
  padding: 1.5rem 1.5rem 0 1.5rem;

  &__title {
    padding-bottom: 1.5rem;
    font-size: 1.5rem;
    line-height: 1.9rem;
    font-weight: 700;
    border-bottom: 1px solid $cAddLight;
  }

  &__inner {
    margin-top: 2.5rem;
    margin-bottom: 5rem;
  }
}
</style>
